var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 根据 level 获取相关数据
 */
export var getTreeLevelData = function (data, level) {
    var _a = data.children, children = _a === void 0 ? [] : _a, _b = data.g_level, g_level = _b === void 0 ? 0 : _b;
    if (level <= 0) {
        return data;
    }
    return __assign(__assign({}, data), { children: g_level + 1 < level
            ? children === null || children === void 0 ? void 0 : children.map(function (item) {
                return getTreeLevelData(item, level);
            })
            : [] });
};
